import axiosInstant from '../../api';
import { getSignedRequestEndpoint, postProfileEndpoint } from '../../api/endpoints';
import config from '../../config';

const bucket = 'desirelist-site-videos';

// Reject on a non-2xx so an expired/misconfigured signed URL surfaces as a
// failed upload instead of a saved URL that points at nothing.
const putFile = async (url, file) => {
  const response = await fetch(`${url}`, { method: 'PUT', body: file });
  if (!response.ok) {
    throw new Error(`UploadFailed:${response.status}`);
  }
  return response;
};
const fetchSignedRequest = (name) => axiosInstant.get(getSignedRequestEndpoint(name, bucket));

export const uploadImage = async (image, id, extension) => {
  try {
    const customName = `user_${id}_${Date.now()}.${extension}`;
    const { data } = await fetchSignedRequest(customName);
    const payload = new File([image], customName);
    await putFile(data.signedRequest, payload);
    return data.url;
  } catch (e) {
    console.log('ERROR', e);
  }
  return null;
};

export const handleProfileImageUpdate = async (values, user, onError) => {
  try {
    let avatarUrl = null;

    if (values.avatarFile && values.avatarFile.file && values.avatarFile.extension) {
      try {
        avatarUrl = await uploadImage(values.avatarFile.file, user.userid, values.avatarFile.extension);
        if (avatarUrl) {
          values.avatar = avatarUrl;
        }
      } catch (error) {
        if (onError) onError("Avatar upload failed");
        return null;
      }
    }
    
    else if (values.avatar && values.avatar.startsWith('data:image/')) {
      try {
        const response = await fetch(values.avatar);
        const blob = await response.blob();
        const file = new File([blob], 'avatar.jpg', { type: blob.type });
        const extension = blob.type.replace('image/', '');
        
        avatarUrl = await uploadImage(file, user.userid, extension);
        if (avatarUrl) {
          values.avatar = avatarUrl;
        }
      } catch (error) {
        if (onError) onError("Base64 upload failed");
        return null;
      }
    }
    
    else if (values.avatar && values.avatar.startsWith('http')) {
      avatarUrl = values.avatar;
    }

    return avatarUrl;
  } catch (error) {
    if (onError) onError("Profile image update failed");
    return null;
  }
};

export const updateUserStore = async (updateUserInfo) => {
  try {
    await updateUserInfo();
  } catch (storeError) {
    console.error('Failed to update user store:', storeError);
  }
};
